import * as ko from "knockout";

import { PliCallSignInHandlerSettings, PliCallSignInHandler } from "../core/call";
import { PliFormsRegistry } from "../forms/forms";

import { openSignInForm } from "./signInForm";


/**
 * Legacy sign-in handler that reloads the page, forcing a redirect to the sign-in form.
 */
function legacySignInHandler(): ko.Observable<boolean> {
    location.reload(true);
    return ko.observable(true);
}

/**
 * Pli's built-in sign-in logic (compatible with "call.PliCallSignInHandler").
 *
 * Shows sign-in form and returns a subscribable that will notify
 * subscribers when user sign-in succeeds.
 */
function signInHandler(pliFormsRegistry: PliFormsRegistry, settings?: PliCallSignInHandlerSettings): ko.Observable<boolean> {
    return openSignInForm(settings).isDone; // show the form, use its "isDone" observable to get notified when the form closes
}

export function createSignInHandler(pliFormsRegistry: PliFormsRegistry): PliCallSignInHandler {
    return (settings => signInHandler(pliFormsRegistry, settings));
}

export function createLegacySignInHandler(): PliCallSignInHandler {
    return legacySignInHandler;
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/forms-signin/index.ts